import React from "react";
import axios from "axios";

import { withStyles, makeStyles } from "@material-ui/core/styles";
import Paper from "@material-ui/core/Paper";
import Table from "@material-ui/core/Table";
import TableBody from "@material-ui/core/TableBody";
import TableCell from "@material-ui/core/TableCell";
import TableContainer from "@material-ui/core/TableContainer";
import TableHead from "@material-ui/core/TableHead";
import TableRow from "@material-ui/core/TableRow";
import CallIcon from "@material-ui/icons/Call";
import AlternateEmailIcon from "@material-ui/icons/AlternateEmail";
import PermIdentityIcon from "@material-ui/icons/PermIdentity";
import { useLocation, useParams } from 'react-router-dom';
import Constants from "../../Utils/Constants";
import LoadingProgress from "../../Common/LoadingProgress";
import { getToken, getHeaders } from "../../Utils/Common";
import store from "../../Common/storage";
import Header from "../../assets/components/header";
import DialogTitle from "@material-ui/core/DialogTitle";
import Dialog from "@material-ui/core/Dialog";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
import Pagination from '@material-ui/lab/Pagination';
import "./../../index.css";
import toastMaker from "../../Common/toastmaker";



const StyledTableCell = withStyles((theme) => ({
  body: {
    fontSize: 16,
    fontWeight: 600,
    padding: 15,
  },
}))(TableCell);

const StyledTableRow = withStyles((theme) => ({
  root: {
    "&:nth-of-type(even)": {
      backgroundColor: "rgba(251, 220, 119, 0.28)",
    },
  },
}))(TableRow);

const useStyles = makeStyles({
  root: {
    width: "100%",
  },
  container: {
    maxHeight: "100%",
  },
});

export default function StickyHeadTable(props) {
  const classes = useStyles();
  const [serverData, setServerData] = React.useState(store.get("history"));
  const [page, setPage] = React.useState(1);
  const [pageCount, setPageCount] = React.useState(0);
  const location = useLocation();
  const [accid, setAccid] = React.useState()
  const [openModal, setOpenModal] = React.useState(false)
  const [openModalType, setOpenModalType] = React.useState()
  const [transactions, setTransactions] = React.useState()
  const [creditsTransactions, setCreditsTransactions] = React.useState()
  const [isMaster, setIsMaster] = React.useState(false)
  const [isLoading, setIsLoading] = React.useState(false);
  const [reportData, setReportData] = React.useState(null);
  const [reportLoading, setReportLoading] = React.useState(false);
  const [reportPage, setReportPage] = React.useState(1);

  const getDefaultDates = () => {
    const tz = 'Australia/Sydney';
    const parts = new Intl.DateTimeFormat('en-AU', { timeZone: tz, year: 'numeric', month: '2-digit' })
      .formatToParts(new Date());
    const auYear  = parseInt(parts.find(p => p.type === 'year').value);
    const auMonth = parseInt(parts.find(p => p.type === 'month').value); // 1-12
    const lastMonth     = auMonth === 1 ? 12 : auMonth - 1;
    const lastMonthYear = auMonth === 1 ? auYear - 1 : auYear;
    const pad = n => String(n).padStart(2, '0');
    const daysInLastMonth = new Date(lastMonthYear, lastMonth, 0).getDate();
    return {
      from: `${lastMonthYear}-${pad(lastMonth)}-01`,
      to:   `${lastMonthYear}-${pad(lastMonth)}-${pad(daysInLastMonth)}`,
    };
  };
  const defaultDates = getDefaultDates();
  const [reportDateFrom, setReportDateFrom] = React.useState(defaultDates.from);
  const [reportDateTo,   setReportDateTo]   = React.useState(defaultDates.to);

  const fmtDate = iso => {
    if (!iso) return '';
    return new Date(iso).toLocaleDateString('en-GB', { day: '2-digit', month: 'short', year: 'numeric' }).replace(/ /g, '-');
  };
  const fmtDateTime = iso => {
    if (!iso) return '';
    const d = new Date(iso);
    return `${fmtDate(iso)} ${d.toLocaleTimeString('en-AU')}`;
  };

  let interval = null;

  const handleChange = (event, value) => {
    setPage(value);
  };

  React.useEffect(() => {
    setIsMaster(store.get('user').configs.filter(c => c.id == store.get('user').partner_id)[0]?.is_master)
    let id = location.pathname.split('/').pop()
    load(id)
    setAccid(id)
  }, []);

  const load = id => {
    axios.get(Constants.getApiPathWithConfigId(Constants.configurationsApiPath, id), getHeaders())
                      .then(response => {
                        setServerData(response.data.data)
                      }).catch(error => console.error(error))
  };

  const addCredits = credits => {
    if(credits == 0) {
      alert('Please provide valid credits amount')
    }
    if(credits > 0) {
      // add
      axios.post(Constants.creditsAddApiPath, {
        to_account: accid,
        credits: credits,
        note: `${credits} Credits added`,
        // reference: "company_config",
        // reference_id: store.get('user').partner_id
      }, getHeaders())
            .then(response => {
              load(accid)
            }).catch(error => console.error(error))
    }
    if(credits < 0) {
      //substact
      axios.post(Constants.creditsRemoveApiPath, {
        to_account: accid,
        credits: (credits * -1),
        note: `${credits * -1} Credits removed`,
        // reference: "company_config",
        // reference_id: store.get('user').partner_id
      }, getHeaders())
                      .then(response => {
                        load(accid)
                      }).catch(error => console.error(error))
    }
  }

  React.useEffect(() => {
    if(openModal && openModalType == 'transactions') {
        getTransactions()
    }
  }, [openModal, page])

  const getTransactions = () => {
    axios.get(Constants.getApiPathWithConfigId(Constants.gettransactionsApiPath, accid)+ `?per_page=50&page=${page}&order_by=id&order=desc`,  getHeaders())
      .then(t => {
        setPageCount(t.data.meta.last_page)
        setTransactions(t.data.data)
        setCreditsTransactions(t.data.meta.credits)
      })
  }

  const getCreditReport = (dateFrom, dateTo, page = 1, clearAll = true) => {
    setReportLoading(true);
    if (clearAll) setReportData(null);
    axios.get(
      `${Constants.creditReportApiPath}/${accid}?date_from=${dateFrom} 00:00:00&date_to=${dateTo} 23:59:59&per_page=50&page=${page}`,
      getHeaders()
    )
      .then(r => setReportData(r.data.data))
      .catch(error => console.error(error))
      .finally(() => setReportLoading(false));
  };

  const onEditAcDetailsSubmit = () => {
      setIsLoading(true);
      axios.post(Constants.checkAcCredsApiPath, {
        host: serverData.host,
        key: serverData.api_key
      }, getHeaders())
            .then(response => {
              axios.put(Constants.getApiPathWithConfigId(Constants.configurationsApiPath, accid), {
                alias: serverData.alias,
                host: serverData.host,
                api_key: serverData.api_key
              }, getHeaders())
                    .then(response => {
                      setIsLoading(false);
                      toastMaker.makeToast("Details updated successfully", {
                                            variant: "success",
                                      })
                    }).catch(e => {})
                    .catch(
                      error => toastMaker.makeToast("Something went wrong, please try again", {
                                            variant: "error",
                                      })
                      )
            })
            .catch(
              error => toastMaker.makeToast("Wrong details, Please check API URL and API KEY", {
                                    variant: "error",
                              })
              )
    };

  const getTallbobReports = () => {
    return <div>
      Coming soon.
    </div>
  }

  if (!serverData) {
    return <LoadingProgress />;
  }

  return (
    <div className="panal-viewport middle-container"> 
      <Header name={`Manage Account`} />
      <Paper className={`${classes.root} pb-2`}>
        <div className="MuiPaper-root box-viewport-set md-view MuiPaper-elevation3 MuiPaper-rounded" style={{margin: "0px auto 10px", maxWidth: "700px", padding: "10px"}}>
          <div>
            <p className="MuiTypography-root jss26 MuiTypography-body1">Basic Details</p>
            <form>
              <label>
                Company: {serverData?.name}
              </label>
              <label>
                Country: {serverData?.country}
              </label>
              <label>
                Zipcode: {serverData?.zipcode}
              </label>
              <label style={{display: 'flex', alignItems: 'center', gap: '12px'}}>
                Status:
                <div
                  onClick={() => {
                    const newStatus = serverData.status == 1 ? 0 : 1;
                    const label = newStatus ? 'Active' : 'Inactive';
                    if (!window.confirm(`Switch ${serverData.name} to ${label}?`)) return;
                    axios.put(Constants.getApiPathWithConfigId(Constants.configurationsApiPath, accid), {
                      status: newStatus
                    }, getHeaders())
                      .then(() => {
                        setServerData({...serverData, status: newStatus});
                        toastMaker.makeToast(`Status updated to ${label}`, { variant: 'success' });
                      })
                      .catch(() => toastMaker.makeToast('Failed to update status', { variant: 'error' }));
                  }}
                  style={{
                    display: 'flex',
                    alignItems: 'center',
                    gap: '8px',
                    cursor: 'pointer',
                    userSelect: 'none',
                  }}
                >
                  <div style={{
                    position: 'relative',
                    width: '48px',
                    height: '26px',
                    borderRadius: '13px',
                    backgroundColor: serverData?.status == 1 ? '#28a745' : '#ccc',
                    transition: 'background-color 0.25s',
                    flexShrink: 0,
                  }}>
                    <div style={{
                      position: 'absolute',
                      top: '3px',
                      left: serverData?.status == 1 ? '25px' : '3px',
                      width: '20px',
                      height: '20px',
                      borderRadius: '50%',
                      backgroundColor: '#fff',
                      boxShadow: '0 1px 3px rgba(0,0,0,0.3)',
                      transition: 'left 0.25s',
                    }} />
                  </div>
                  <span style={{
                    fontSize: '14px',
                    fontWeight: 600,
                    color: serverData?.status == 1 ? '#1a7a3c' : '#a71d2a',
                  }}>
                    {serverData?.status == 1 ? 'Active' : 'Inactive'}
                  </span>
                </div>
              </label>
            </form>
          </div>
        </div>

        <div className="MuiPaper-root box-viewport-set md-view MuiPaper-elevation3 MuiPaper-rounded" style={{margin: "0px auto 10px", maxWidth: "700px", padding: "10px"}}>
          <div>
            <p className="MuiTypography-root jss26 MuiTypography-body1">ActiveCampaign Details</p>

            <form>
              <label>Alias</label>
              <div className="form-groups">
                <input
                  id="alias"
                  value={serverData.alias}
                  onChange={(event) => {
                    setServerData({...serverData, alias: event.target.value})
                  }}
                  type="text"
                  className="form-controls"
                />
              </div>

              <label>API URL</label>
              <div className="form-groups">
                <input
                  id="host"
                  value={serverData.host}
                  onChange={(event) => {
                    setServerData({...serverData, host: event.target.value})
                  }}
                  type="text"
                  className="form-controls"
                />
              </div>

              <label>API Key</label>
              <div className="form-groups">
                <input
                  id="apikey"
                  value={serverData.api_key}
                  onChange={(event) => {
                    setServerData({...serverData, api_key: event.target.value})
                  }}
                  type="text"
                  className="form-controls"
                />
              </div>
              <p
                className="c-button c-button--secondary text-uppercase text-light"
                style={{marginTop: '10px'}}
                onClick={() => {
                  onEditAcDetailsSubmit()
                }}
              >Save</p>
            </form>
          </div>
        </div>

        <div className="MuiPaper-root box-viewport-set md-view MuiPaper-elevation3 MuiPaper-rounded" style={{margin: "0px auto 10px", maxWidth: "700px", padding: "10px"}}>
          <div>
            <p className="MuiTypography-root jss26 MuiTypography-body1">Credits Details</p>
            <form>
              <label>
                Current Balance: {serverData.last_balance}
              </label>
              <div style={{
                display: 'flex',
                gap: '10px'
              }}>
                {serverData.last_balance && <p
                  className="c-button c-button--secondary text-uppercase text-light"
                  style={{marginTop: '10px'}}
                  onClick={() => {
                    let conf = window.confirm(`Are you sure to add 100 credits to ${serverData.name}?`)
                    if(conf) {
                      addCredits(100)
                    }
                  }}
                >Add 100</p>}
                <p
                  className="c-button c-button--secondary text-uppercase text-light"
                  style={{marginTop: '10px'}}
                  onClick={() => {
                    let conf = window.prompt(`How many credits you want to add to ${serverData.name}?`)
                    if(conf) {
                      addCredits(conf)
                    }
                  }}
                >Add</p>
                <p
                  className="c-button c-button--secondary text-uppercase text-light"
                  style={{marginTop: '10px'}}
                  onClick={() => {
                    let conf = window.prompt(`How many credits you want to substact from ${serverData.name}?`)
                    if(conf) {
                      addCredits(conf * -1)
                    }
                  }}
                >Substact</p>
                {/* <p
                  className="c-button c-button--secondary text-uppercase text-light"
                  style={{marginTop: '10px'}}
                  onClick={() => {
                    setOpenModalType('transactions')
                    setOpenModal(true)
                  }}
                >Transactions</p> */}
                {/* <p
                  className="c-button c-button--secondary text-uppercase text-light"
                  style={{marginTop: '10px'}}
                  onClick={() => {
                    setOpenModalType('tallbob')
                    setOpenModal(true)
                  }}
                >TallBob Reports</p> */}
                {
                  serverData.allow_exceed ? <p
                    className="c-button c-button--secondary text-uppercase text-light"
                    style={{marginTop: '10px'}}
                    onClick={() => {
                      setOpenModalType('creditreport')
                      setOpenModal(true)
                      getCreditReport(reportDateFrom, reportDateTo)
                    }}
                  >Credit Report</p> : <></>
                }
              </div>
            </form>
          </div>
        </div>

        <div className="MuiPaper-root box-viewport-set md-view MuiPaper-elevation3 MuiPaper-rounded" style={{margin: "0px auto 10px", maxWidth: "700px", padding: "10px"}}>
          <div>
            <p className="MuiTypography-root jss26 MuiTypography-body1">Payment Type</p>
            <form>
              <label>
                Current Type: <strong>{serverData.allow_exceed ? 'Postpaid' : 'Prepaid'}</strong>
              </label>
              <div style={{display: 'flex', gap: '10px', marginTop: '10px'}}>
                <p
                  className="c-button c-button--secondary text-uppercase text-light"
                  style={{marginTop: '0'}}
                  onClick={() => {
                    const newType = serverData.allow_exceed ? 0 : 1;
                    const label   = newType ? 'Postpaid' : 'Prepaid';
                    if(!window.confirm(`Switch ${serverData.name} to ${label}?`)) return;
                    axios.put(Constants.getApiPathWithConfigId(Constants.configurationsApiPath, accid), {
                      allow_exceed: newType
                    }, getHeaders())
                      .then(() => {
                        setServerData({...serverData, allow_exceed: newType});
                        toastMaker.makeToast(`Payment type updated to ${label}`, { variant: 'success' });
                      })
                      .catch(() => toastMaker.makeToast('Failed to update payment type', { variant: 'error' }));
                  }}
                >Switch to {serverData.allow_exceed ? 'Prepaid' : 'Postpaid'}</p>
              </div>
            </form>
          </div>
        </div>

        <div className="MuiPaper-root box-viewport-set md-view MuiPaper-elevation3 MuiPaper-rounded" style={{margin: "0px auto 10px", maxWidth: "700px", padding: "10px"}}>
            <div>
              <p className="MuiTypography-root jss26 MuiTypography-body1">Longcodes</p>
              <form>
                <ol style={{margin: '0 30px'}}>
                  {
                    serverData.longcodes.map(l => <li style={{margin: '5px 0'}}>
                      {l.number}
                      <p
                        className="c-button text-uppercase text-light"
                        style={{margin: '0 20px', display: 'inline-block'}}
                        onClick={() => {
                          axios.delete(Constants.getApiPathWithConfigId(Constants.virtualnumbers, accid) + `/${l.id}`, getHeaders())
                                .then(response => {
                                  load(accid)
                                }).catch(error => console.error(error))
                        }}
                      >Delete</p>
                  </li>)
                  }
                </ol>
                <p
                  className="c-button c-button--secondary text-uppercase text-light "
                  style={{marginTop: '10px'}}
                  onClick={() => {
                    let virtual_number = window.prompt('Please provide number')
                    axios.post(Constants.getApiPathWithConfigId(Constants.virtualnumbers, accid), {
                            number: virtual_number,
                          }, getHeaders())
                                .then(response => {
                                  load(accid)
                                }).catch(error => console.error(error))
                  }}
                >Add Longcode</p>
              </form>
            </div>
          </div>

        <div className="MuiPaper-root box-viewport-set md-view MuiPaper-elevation3 MuiPaper-rounded" style={{margin: "0px auto 10px", maxWidth: "700px", padding: "10px"}}>
          <div>
            <p className="MuiTypography-root jss26 MuiTypography-body1">Users</p>
            <form>
              <ol style={{margin: '0 30px'}}>
                {
                  serverData.users.map(l => <li>
                    {`${l.name} `}
                    {'('}<a href={`mailto:${l.email}`} className="MuiTypography-root MuiListItemText-secondary MuiTypography-body2 MuiTypography-colorTextSecondary">
                       {l.email} 
                    </a>{')'}
                  </li>)
                }
              </ol>
            </form>
          </div>
        </div>

        <Dialog
          onClose={() => setOpenModal(false)}
          aria-labelledby="simple-dialog-title"
          open={openModal}
          scroll={"body"}
          fullWidth={true}
          maxWidth="xl"
        >
          {openModalType == 'transactions' ? <div className="">
              <DialogTitle id="simple-dialog-title">Transactions</DialogTitle>
              <DialogContent>
                <TableContainer component={Paper}>
                  <Table className={classes.table} aria-label="customized table">
                    <TableHead style={{
                                    width: "calc(100% - 1em)",
                                    display: "table",
                                    tableLayout: "fixed"
                                  }}>
                      <TableRow id="table-head_rw">
                        <StyledTableCell className="table-hd">
                          From
                        </StyledTableCell>
                        <StyledTableCell className="table-hd">
                          To
                        </StyledTableCell>
                        <StyledTableCell className="table-hd">
                          Credits
                        </StyledTableCell>
                        {/* <StyledTableCell className="table-hd">
                          Narration
                        </StyledTableCell> */}
                        <StyledTableCell className="table-hd">
                          Send Date, Time
                        </StyledTableCell>
                      </TableRow>
                    </TableHead>
                    <TableBody style={{
                                    height: "310px",
                                    overflow: "auto",
                                    width: "100%",
                                    tableLayout: "fixed",
                                    display: "block"
                                  }}>
                      {
                        transactions && transactions?.length && transactions?.map((row) => 
                          <StyledTableRow
                            hover
                            role="checkbox"
                            tabIndex={-1}
                            key={row.id}
                            style={{
                                  display: "table",
                                  width: "100%",
                                  tableLayout: "fixed"
                            }}
                          >
                            <StyledTableCell
                              component="th"
                              scope="row"
                              style={{maxWidth: '170px'}}
                            >
                              <div className="speech-bubble">
                                <span>{row.from_account_name}</span>
                              </div>
                            </StyledTableCell>
                            <StyledTableCell
                              component="th"
                              scope="row"
                              style={{maxWidth: '170px'}}
                            >
                              <div className="speech-bubble">
                                <span>{row.to_account_name}</span>
                              </div>
                            </StyledTableCell>
                            <StyledTableCell
                              component="th"
                              scope="row"
                              style={{maxWidth: '170px'}}
                            >
                              <div className="speech-bubble">
                                <span>{row.credits}</span>
                              </div>
                            </StyledTableCell>
                            {/* <StyledTableCell
                              component="th"
                              scope="row"
                              style={{maxWidth: '170px'}}
                            >
                              <div className="speech-bubble">
                                <span>{row.narration.replace('substacted', 'subtracted')}</span>
                              </div>
                            </StyledTableCell> */}
                            <StyledTableCell
                              component="th"
                              scope="row"
                              style={{maxWidth: '170px'}}
                            >
                              <div className="speech-bubble">
                                <span>{new Date(row.created_at).toLocaleString()}</span>
                              </div>
                            </StyledTableCell>
                          </StyledTableRow>
                        )
                      }
                    </TableBody>
                  </Table>
                </TableContainer>
                {pageCount > 0 && <div className={`${classes.root} mt-3 mb-3 d-flex justify-content-end`}>
                  <Pagination 
                    count={pageCount} 
                    page={page} 
                    onChange={handleChange} 
                    variant="outlined" 
                    shape="rounded"
                    />
                </div>}

                <TableContainer component={Paper} style={{margin: '10px 0'}}>
                  <Table className={classes.table} aria-label="customized table">
                    <TableHead>
                      <TableRow id="table-head_rw">
                        <StyledTableCell className="table-hd">
                          Transactions Total
                        </StyledTableCell>
                        <StyledTableCell className="table-hd">
                          Balance 
                        </StyledTableCell>
                      </TableRow>
                    </TableHead>
                    <TableBody>
                      <StyledTableRow
                        hover
                        role="checkbox"
                        tabIndex={-1}
                      >
                        <StyledTableCell
                          component="th"
                          scope="row"
                          style={{maxWidth: '170px'}}
                        >
                          <div className="speech-bubble">
                            <span>
                              {
                                creditsTransactions
                              }
                            </span>
                          </div>
                        </StyledTableCell>
                         <StyledTableCell
                          component="th"
                          scope="row"
                          style={{maxWidth: '170px'}}
                        >
                          <div className="speech-bubble">
                            <span style={{
                              float: 'left',
                              margin: '10px 20px 0 0'
                            }}
                            >{serverData.last_balance}</span>
                            
                          {creditsTransactions != serverData.last_balance && <p
                            className="c-button c-button--secondary text-uppercase text-light"
                            style={{marginTop: '0', float: 'left'}}
                            onClick={() => {
                              axios.put(Constants.getApiPathWithConfigId(Constants.configurationsApiPath, accid), {
                                last_balance: creditsTransactions
                              }, getHeaders())
                                    .then(t => {
                                      load(accid)
                                    })
                            }}
                          >Rebalance</p>}
                          </div>
                        </StyledTableCell>
                      </StyledTableRow>
                    </TableBody>
                  </Table>
                </TableContainer>
                
              </DialogContent>
            </div>
          : openModalType == 'creditreport' ? <div>
              <DialogTitle id="simple-dialog-title">Credit Report - {serverData.name}</DialogTitle>
              <DialogContent>
                <div style={{display: 'flex', gap: '10px', alignItems: 'center', marginBottom: '16px', flexWrap: 'wrap'}}>
                  <div>
                    <label style={{padding: 0}}>From</label>
                    <input
                      type="date"
                      value={reportDateFrom}
                      onChange={e => setReportDateFrom(e.target.value)}
                      className="form-controls"
                      style={{width: 'auto'}}
                    />
                  </div>
                  <div>
                    <label style={{padding: 0}}>To</label>
                    <input
                      type="date"
                      value={reportDateTo}
                      onChange={e => setReportDateTo(e.target.value)}
                      className="form-controls"
                      style={{width: 'auto'}}
                    />
                  </div>
                  <p
                    className="c-button c-button--secondary text-uppercase text-light"
                    style={{marginTop: '25px'}}
                    onClick={() => { setReportPage(1); getCreditReport(reportDateFrom, reportDateTo, 1); }}
                  >Fetch</p>
                </div>

                {reportLoading && <LoadingProgress />}

                {!reportLoading && reportData && <>
                  {/* Message counts for the selected period */}
                  <div style={{display: 'flex', alignItems: 'center', gap: '12px', marginBottom: '6px'}}>
                    <p style={{fontWeight: 600, margin: 0}}>
                      Period: {fmtDate(reportData.date_from)} – {fmtDate(reportData.date_to)}
                    </p>
                    <button
                      onClick={() => {
                        const month = reportData.date_from
                          ? new Date(reportData.date_from).toLocaleDateString('en-AU', { month: 'long' })
                          : 'Period';
                        const text = [
                          `Total SMS sent Month of ${month}: ${Math.abs(reportData.summary?.sms_sent ?? 0)}`,
                          `Total SMS Units Month of ${month}: ${Math.abs(reportData.summary?.sms ?? 0)}`,
                          `Total MMS sent Month of ${month}: ${Math.abs(reportData.summary?.mms_sent ?? 0)}`,
                          ``,
                          `Total Units: SMS Units + MMS Units Month of ${month}: ${Math.abs(reportData.summary?.total_units ?? 0)}`,
                          ``,
                          `Total SMS + MMS Units Calendar Year to Date: ${Math.abs(reportData.summary?.ytd_units ?? 0)}`,
                        ].join('\n');
                        navigator.clipboard.writeText(text)
                          .then(() => toastMaker.makeToast('Summary copied to clipboard', { variant: 'success' }))
                          .catch(() => toastMaker.makeToast('Failed to copy', { variant: 'error' }));
                      }}
                      style={{
                        padding: '4px 12px',
                        fontSize: '13px',
                        cursor: 'pointer',
                        borderRadius: '4px',
                        border: '1px solid #ccc',
                        background: '#f5f5f5',
                      }}
                    >Copy Summary</button>
                  </div>
                  <TableContainer component={Paper} style={{marginBottom: '16px'}}>
                    <Table aria-label="credit summary">
                      <TableHead>
                        <TableRow>
                          <StyledTableCell>SMS Sent</StyledTableCell>
                          <StyledTableCell>MMS Sent</StyledTableCell>
                          <StyledTableCell>Total Units (SMS + MMS)</StyledTableCell>
                        </TableRow>
                      </TableHead>
                      <TableBody>
                        <StyledTableRow>
                          <StyledTableCell>{Math.abs(reportData.summary?.sms_sent ?? 0)}</StyledTableCell>
                          <StyledTableCell>{Math.abs(reportData.summary?.mms_sent ?? 0)}</StyledTableCell>
                          <StyledTableCell><strong>{Math.abs(reportData.summary?.total_units ?? 0)}</strong></StyledTableCell>
                        </StyledTableRow>
                      </TableBody>
                    </Table>
                  </TableContainer>

                  {/* Credits breakdown for the selected period */}
                  <TableContainer component={Paper} style={{marginBottom: '16px'}}>
                    <Table aria-label="credits breakdown">
                      <TableHead>
                        <TableRow>
                          <StyledTableCell>All Credits</StyledTableCell>
                          <StyledTableCell>SMS Credits</StyledTableCell>
                          <StyledTableCell>MMS Credits</StyledTableCell>
                        </TableRow>
                      </TableHead>
                      <TableBody>
                        <StyledTableRow>
                          <StyledTableCell>{Math.abs(reportData.summary?.all ?? 0)}</StyledTableCell>
                          <StyledTableCell>{Math.abs(reportData.summary?.sms ?? 0)}</StyledTableCell>
                          <StyledTableCell>{Math.abs(reportData.summary?.mms ?? 0)}</StyledTableCell>
                        </StyledTableRow>
                      </TableBody>
                    </Table>
                  </TableContainer>

                  {/* Calendar year-to-date total */}
                  <TableContainer component={Paper} style={{marginBottom: '16px'}}>
                    <Table aria-label="ytd summary">
                      <TableHead>
                        <TableRow>
                          <StyledTableCell colSpan={2}>
                            Total SMS + MMS Units — Calendar Year to Date ({fmtDate(reportData.summary?.ytd_from)} – {fmtDate(reportData.summary?.ytd_to)})
                          </StyledTableCell>
                        </TableRow>
                      </TableHead>
                      <TableBody>
                        <StyledTableRow>
                          <StyledTableCell><strong>{Math.abs(reportData.summary?.ytd_units ?? 0)}</strong></StyledTableCell>
                        </StyledTableRow>
                      </TableBody>
                    </Table>
                  </TableContainer>

                  <TableContainer component={Paper}>
                    <Table aria-label="credit transactions" style={{display: 'block', maxHeight: '400px', overflowY: 'auto'}}>
                      <TableHead style={{display: 'table', width: '100%', tableLayout: 'fixed'}}>
                        <TableRow>
                          <StyledTableCell>Date</StyledTableCell>
                          <StyledTableCell>Note</StyledTableCell>
                          <StyledTableCell style={{width: '120px'}}>Credits</StyledTableCell>
                        </TableRow>
                      </TableHead>
                      <TableBody>
                        {reportData.transactions?.data?.length ? reportData.transactions.data.map(row => (
                          <StyledTableRow key={row.id} style={{display: 'table', width: '100%', tableLayout: 'fixed'}}>
                            <StyledTableCell>{fmtDateTime(row.created_at)}</StyledTableCell>
                            <StyledTableCell>{row.note}</StyledTableCell>
                            <StyledTableCell style={{width: '120px'}}>{row.credits}</StyledTableCell>
                          </StyledTableRow>
                        )) : (
                          <StyledTableRow style={{display: 'table', width: '100%', tableLayout: 'fixed'}}>
                            <StyledTableCell colSpan={3}>No transactions found for this period.</StyledTableCell>
                          </StyledTableRow>
                        )}
                      </TableBody>
                    </Table>
                  </TableContainer>

                  {reportData.transactions?.last_page > 1 && (
                    <div className={`${classes.root} mt-3 mb-3 d-flex justify-content-end`}>
                      <Pagination
                        count={reportData.transactions.last_page}
                        page={reportPage}
                        onChange={(_, val) => {
                          setReportPage(val);
                          getCreditReport(reportDateFrom, reportDateTo, val, false);
                        }}
                        variant="outlined"
                        shape="rounded"
                      />
                    </div>
                  )}
                </>}
              </DialogContent>
            </div> : <div className="import-template-modal">
              <DialogTitle id="simple-dialog-title">TallBob Reports</DialogTitle>
                <DialogContent>
                  {
                    getTallbobReports()
                  }
                </DialogContent>

              </div>
            }
        </Dialog>
      </Paper>
    </div>
  );
}
